import { useContext, useState } from 'react';
import moment from 'moment';
import { toast } from 'react-toastify';
import Radio from '../../../components/Radio';
import Input from '../../../components/Form/Input';
import Button from '../../../components/Button';
import inputMask from '../../../util/mask';
import { DivFooter, ParentalConsentContext } from '../index';
import { Actions, Categories } from '../../../types/gtm';
import { useAuth } from '../../../hooks/useAuth';

const FormBlock = () => {
  const { user } = useAuth();
  const { setStep, setDateToBlock, underageUser } = useContext(
    ParentalConsentContext,
  );
  const [check, setCheck] = useState<string>('');
  const [customDate, setCustomDate] = useState<string>('');

  function handleInput(e: HTMLInputElement) {
    const blockDate = inputMask.date;
    setCustomDate(blockDate(e.value));
  }

  function validateDate() {
    const now = new Date();
    if (!customDate) {
      return 'A data final deve ser informada.';
    }

    if (!moment(customDate, 'DD/MM/YYYY').isValid()) {
      return 'Você precisa informar uma data válida.';
    }

    if (customDate && moment(customDate, 'DD/MM/YYYY').isBefore(moment(now))) {
      return 'Você precisa informar uma data posterior a hoje.';
    }

    return '';
  }

  function disabledButton() {
    if (check && check !== 'custom') {
      return false;
    }

    return !(check && check === 'custom' && validateDate() === '');
  }

  function handleSubmit() {
    toast.dismiss();

    if (check === '') {
      toast.info('É necessário selecionar um periodo para bloqueio');
      return;
    }

    let date: any;
    let blockLabel: any;
    if (check === 'custom') {
      date = moment(customDate, 'DD/MM/YYYY');
      blockLabel = `De hoje até ${date.format('DD/MM/YYYY')}`;
    }

    if (check === 'undefined') {
      date = '';
      blockLabel = 'Até eu desbloquear';
    }

    if (check !== 'undefined' && check !== 'custom') {
      const i = parseInt(check, 10);
      date = moment().add(i, 'days');
      blockLabel = `${check} dias`;
    }

    setDateToBlock(date);

    window.dataLayer.push({
      event: 'customEventUserInteraction',
      event_category: Categories.ParentalConsent,
      event_action: Actions.ClickBlockOption,
      event_label: blockLabel,
      bd_suser_code: user?.globoId,
    });

    setStep({ screen: 'confirm', type: 'block' });
  }

  return (
    <>
      <div>
        <h2>Bloqueio temporário</h2>
        <p>
          Limite o uso da Conta Globo de {underageUser.name} e aos Produtos
          Globo associados a ela. Escolha uma das opções de período abaixo:
        </p>
      </div>
      <div>
        <ul>
          <li>
            <Radio
              onChange={e => {
                setCheck(e.currentTarget.value);
              }}
              value="7"
              name="bloqueio"
            >
              {' '}
              7 dias
            </Radio>
          </li>
          <li>
            <Radio
              onChange={e => {
                setCheck(e.currentTarget.value);
              }}
              value="15"
              name="bloqueio"
            >
              {' '}
              15 dias
            </Radio>
          </li>
          <li>
            <Radio
              onChange={e => {
                setCheck(e.currentTarget.value);
              }}
              value="30"
              name="bloqueio"
            >
              {' '}
              30 dias
            </Radio>
          </li>
          <li>
            <Radio
              onChange={e => {
                setCheck(e.currentTarget.value);
              }}
              value="undefined"
              name="bloqueio"
            >
              {' '}
              Até eu desbloquear
            </Radio>
          </li>
          <li>
            <Radio
              onChange={e => {
                setCheck(e.currentTarget.value);
              }}
              value="custom"
              name="bloqueio"
            >
              {' '}
              De hoje até
            </Radio>
            {check === 'custom' && (
              <div className="DivInput">
                <Input
                  width="100%"
                  pattern="[0-9]*"
                  onChange={e => handleInput(e.currentTarget)}
                  value={customDate}
                  name="customDate"
                  placeHolderText="dd/mm/aaaa"
                />
                <p>{validateDate()}</p>
              </div>
            )}
          </li>
        </ul>
      </div>
      <DivFooter>
        <Button
          width="264px"
          onClick={() => handleSubmit()}
          disabled={disabledButton()}
          variant="secondary"
        >
          Bloquear Conta Globo
        </Button>
      </DivFooter>
    </>
  );
};

export default FormBlock;
